import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M21 3 3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
}), 'NearMe');